import { FC } from "react";
import { Box, Divider, Typography } from "@mui/material";
import __ from "src/utils/Translations";
import formatDayLabel from "src/utils/Company/Absences/formatDayLabel";
import { PRESENTATION_TYPE } from "src/Pages/Company/Absences/AbsenceRecords/AbsenceRecords.models";
import { EPatternUnit } from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";
import formatBalanceCount from "src/utils/Company/Absences/formatBalanceCount";

interface IBalanceStatusBadgeProps {
  labelUT: string;
  days?: number;
  hours?: number;
  overdueDays?: number;
  overdueHours?: number;
  presentationType?: PRESENTATION_TYPE;
  billingCycle?: EPatternUnit;
  color: string;
}

const BalanceStatusBadge: FC<IBalanceStatusBadgeProps> = ({
  labelUT,
  days,
  hours,
  overdueDays,
  overdueHours,
  presentationType,
  billingCycle,
  color,
}) => {
  const balanceCount = formatBalanceCount({
    days,
    hours,
    presentationType,
    billingCycle,
  });

  return (
    <Box
      sx={{
        background: "white",
        padding: "0.5rem 1rem",
        borderRadius: "0.25rem",
        inlineSize: "fit-content",
      }}
      data-testId="absence-balance-status"
    >
      <Typography variant="subtitle2" component="span">
        {__(labelUT)}:{" "}
      </Typography>
      <Typography
        variant="subtitle2"
        color={color}
        component="span"
        data-testId="absence-balance-status__count"
      >
        {balanceCount}
      </Typography>
      {overdueDays || overdueHours ? (
        <>
          <Divider sx={{ m: "0.5rem 0 0" }} />
          <Typography variant="caption">{__("W tym zaległe")}:</Typography>
          <Typography variant="subtitle2" color="info.dark">
            {`${overdueDays} ${__(
              formatDayLabel(overdueDays!)
            )} / ${overdueHours}h`}
          </Typography>
        </>
      ) : null}
    </Box>
  );
};

export default BalanceStatusBadge;
